import ol = require("ol");
import MapView = require("../views/MapView");
import Portal = require("portal-gis");
import Utils = require("../utils");
import globals = require("../../globals");

var styleDefaults = {
    strokeColor: "rgba(255, 204, 0, 0.2)",
    fillColor: "rgba(255, 153, 0, 0.4)"
};

var proxy = (globals.proxy) ? url => `${globals.proxy}${encodeURI(url)}` : url => url;

class KmlStyles {

    static radius(radius = 5, fillColor = styleDefaults.fillColor, strokeColor = styleDefaults.strokeColor, strokeWidth = 1) {

        var defaultStyle = [new ol.style.Style({
            image: new ol.style.Circle({
                radius: radius,
                fill: new ol.style.Fill({
                    color: fillColor
                }),
                stroke: new ol.style.Stroke({
                    color: strokeColor,
                    width: strokeWidth
                })
            })
        })];

        return (feature, resolution) => {
            return defaultStyle;
        };
    }
}

function getTileOptions(l: Portal.MapLayerLeaf) {

    var options = Utils.asDictionary(l.Options.Values);

    var tileOptions = <olx.layer.TileOptions>{
        visible: "false" !== options["visible"],
        id: l.id,
        title: l.text,
        type: "base",
        componentType: l.componentType,
        assetType: l.assetType
    };
    return tileOptions;
}

class Handler {

    static about = `
Uses native openlayers sources to manage the heatmap layer.
    `;

    static options = {
        "layerType": {
            "about": "Identify the layer type",
            "domain": "kml",
            "default": "kml",
        }
    }

    private static kml(l: Portal.MapLayerLeaf) {

        let options = Utils.asDictionary(l.Options.Values);

        let sourceOptions = <olx.source.VectorOptions>{
            extractStyles: false,
            projection: new ol.proj.Projection({ code: options.srs || "EPSG:4326" }),
            url: proxy(l.url || options["url"])
        };

        let source = new ol.source.KML(sourceOptions);

        let tileOptions = <olx.layer.VectorOptions>getTileOptions(l);
        tileOptions.source = source;
        delete tileOptions["type"];

        let tile = new ol.layer.Heatmap(tileOptions);

        /**
        HACKed to get through heatmap test, maybe this needs to be a handled by a formatter event on the layer?
        <EVENT event="addfeature" mid="app/commands/earthquake-transform" id="earthquake-transform" />
         */
        tile.getSource().on('addfeature', function(event) {
            // 2012_Earthquakes_Mag5.kml stores the magnitude of each earthquake in a
            // standards-violating <magnitude> tag in each Placemark.  We extract it from
            // the Placemark's name instead.
            let name = event.feature.get('name');
            let magnitude = parseFloat(name.substr(2));
            event.feature.set('weight', magnitude - 5);
        });


        return tile;
    }

    static create(args: { layer: Portal.MapLayerLeaf; view: MapView }): ol.layer.Layer {
        var l = args.layer;
        var options = Utils.asDictionary(l.Options.Values);
        var layerType = options["layerType"] || "kml";
        var factory = Handler.kml;
        factory = Handler[layerType] || factory;
        return factory && factory(l);
    }

}

export = Handler;